import { ResourceProps } from "react-admin";
import Icon from "@mui/icons-material/NightShelter";
import { Resource } from "../../enums";
import ListScreen from "./list";
import { EditScreen } from "./edit";

const termsAndConditionsPages: ResourceProps = {
  name: Resource.TERMS_AND_CONDS,
  icon: Icon,
  list: ListScreen,
  edit: EditScreen,
  options: {
    label: "Terms and Conditions",
  },
};

export default termsAndConditionsPages;
